import axios from "axios";

const prepareData = (data) => {return {project_qa_welding_inspections_access_restriction:data}}

// Plural Actions
export const GET_PROJECT_QA_WELDING_INSPECTIONS_ACCESS_RESTRICTIONS = "get_project_qa_welding_inspections_access_restrictions";
export const getProjectQaWeldingInspectionsAccessRestrictions = () => {
	const url = `/project/qa/welding_inspections/access_restrictions.json`
	const request = axios.get(url);
	return {
		type: GET_PROJECT_QA_WELDING_INSPECTIONS_ACCESS_RESTRICTIONS,
		payload: request
	};
};


// Singular Actions
export const CREATE_PROJECT_QA_WELDING_INSPECTIONS_ACCESS_RESTRICTION = "create_project_qa_welding_inspections_access_restriction";
export const createProjectQaWeldingInspectionsAccessRestriction = (data) => {
	const url = `/project/qa/welding_inspections/access_restrictions.json`
	const request = axios({method: "post",url: url,data: prepareData(data)});
	return {
		type: CREATE_PROJECT_QA_WELDING_INSPECTIONS_ACCESS_RESTRICTION,
		payload: request
	};
};

export const GET_PROJECT_QA_WELDING_INSPECTIONS_ACCESS_RESTRICTION = "get_project_qa_welding_inspections_access_restriction";
export const getProjectQaWeldingInspectionsAccessRestriction = (id) => {
	const url = `/project/qa/welding_inspections/access_restrictions/${id}.json`
	const request = axios.get(url);
	return {
		type: GET_PROJECT_QA_WELDING_INSPECTIONS_ACCESS_RESTRICTION,
		payload: request
	};
};

export const UPDATE_PROJECT_QA_WELDING_INSPECTIONS_ACCESS_RESTRICTION = "update_project_qa_welding_inspections_access_restriction";
export const updateProjectQaWeldingInspectionsAccessRestriction = (id,data) => {
	const url = `/project/qa/welding_inspections/access_restrictions/${id}.json`
	const request = axios({method: "patch",url: url,data: prepareData(data)});
	return {
		type: UPDATE_PROJECT_QA_WELDING_INSPECTIONS_ACCESS_RESTRICTION,
		payload: request
	};
};

export const DESTROY_PROJECT_QA_WELDING_INSPECTIONS_ACCESS_RESTRICTION = "destroy_project_qa_welding_inspections_access_restriction";
export const destroyProjectQaWeldingInspectionsAccessRestriction = (id) => {
	const url = `/project/qa/welding_inspections/access_restrictions/${id}.json`
	const request = axios({method: "delete",url: url});
	return {
		type: DESTROY_PROJECT_QA_WELDING_INSPECTIONS_ACCESS_RESTRICTION,
		payload: request
	};
};
